import React, { memo } from 'react'
import { Box } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/ThemeLottie'
import { useThemeContext } from 'hooks/context/useThemeContext'
import { LogoColor } from 'types/types'
import { Logo } from './logos/Logo'

const AppLoader = () => {
  const { darkMode } = useThemeContext()

  return (
    <Box
      flex
      flexCol
      centerChildren
      width="full"
      minHeight="screen"
      gap={20}
      className="bg-surface-flat"
    >
      <Lottie loop src="app-loader" width={80} height={80} />
      <Logo logoColor={darkMode ? LogoColor.LIGHT : LogoColor.DARK} />
    </Box>
  )
}

export default memo(AppLoader)
